import React from 'react';
import Tabs from '../../../../elements/Tabs/Tabs';
import ActiveParticipants from './ActiveParticipants/ActiveParticipants';
import AllParticipants from './AllParticipants/AllParticipants';
import FavoriteParticipants from './FavoriteParticipants/FavoriteParticipants';
import MyContacts from './MyContacts/MyContacts';
import TextSearchParticipants from './TextSearchParticipants/TextSearchParticipants';
import CategoryFilterParticipants from './CategoryFilterParticipants/CategoryFilterParticipants';
import styles from './ParticipantsTabs.module.scss';
import SuggestedParticipants from './SuggestedParticipants';

function ParticipantsTabs(props) {
    const {eventId, filterParams} = props;

    return (
        <Tabs arrows={false}>
            <AllParticipants eventId={eventId} filterParams={filterParams} />
            <SuggestedParticipants eventId={eventId} filterParams={filterParams} />
            <ActiveParticipants eventId={eventId} filterParams={filterParams} />
            <FavoriteParticipants eventId={eventId} filterParams={filterParams} />
            <MyContacts eventId={eventId} filterParams={filterParams} />
            <TextSearchParticipants className={styles.iconTab} eventId={eventId} filterParams={filterParams} />
            <CategoryFilterParticipants className={styles.iconTab} eventId={eventId} filterParams={filterParams} />
        </Tabs>
    );
}

export default ParticipantsTabs;
